// assets/fourpillarsofdestiny-api.js

// 显示全局加载指示器
function showGlobalLoading() {
    const loadingElement = document.getElementById('global-loading');
    if (loadingElement) {
        loadingElement.style.display = 'flex';
    }
}

// 隐藏全局加载指示器
function hideGlobalLoading() {
    const loadingElement = document.getElementById('global-loading');
    if (loadingElement) {
        loadingElement.style.display = 'none';
    }
}

// 在全局作用域添加缓存对象
const wuXingCache = {};

// 异步获取五行描述
async function getWuXingDescription(element, gender) {
    const cacheKey = `${element}_${gender}`;
    if (wuXingCache[cacheKey]) {
        return wuXingCache[cacheKey];
    }

    try {
        const apiUrl = `https://fourpillarsofdestiny-basic-api.hammett-qi.workers.dev/five/${encodeURIComponent(element)}?gender=${gender}`;
        const response = await fetch(apiUrl);
        const data = await response.json();

        // 组合结果
        let result = gender === '男' ? data.male :
            gender === '女' ? data.female :
            data.common || '';

        // 缓存结果
        wuXingCache[cacheKey] = result;
        return result;

    } catch (error) {
        console.error('获取五行描述失败:', error);
        return '';
    }
}

// 统一封装解析函数
async function getPillarAnalysis(type, ganZhi, gender) {
    try {
        // 转换类型为中文
        const typeMap = {
            year: '年',
            month: '月',
            day: '日',
            time: '时',
            five: '五'
        }
        const chineseType = typeMap[type]

        // 将中文性别转换为API参数
        const genderParam = gender === '男' ? 'male' :
            gender === '女' ? 'female' : 'common'

        // 调用API
        const apiUrl = `https://fourpillarsofdestiny-basic-api.hammett-qi.workers.dev/${type}/${encodeURIComponent(ganZhi)}?gender=${genderParam}`
        const response = await fetch(apiUrl)
        const data = await response.json()

        // 组合结果
        let result = ''

        // 优先返回性别特定结果
        if (gender === '男' && data.male) {
            result = data.male
        } else if (gender === '女' && data.female) {
            result = data.female
        }

        // 添加通用解析
        if (data.common) {
            result = result ? `${result} ${data.common}` : data.common
        }

        return result || '暂无解析'

    } catch (error) {
        console.error('解析获取失败:', error)
        return '解析服务暂时不可用'
    }
}

// 各柱解析函数 - 保持异步但直接返回Promise
function getYearPillarAnalysis(yearGanZhi, gender) {
    return getPillarAnalysis('year', yearGanZhi, gender)
}

function getMonthPillarAnalysis(monthGanZhi, gender) {
    return getPillarAnalysis('month', monthGanZhi, gender)
}

function getDayPillarAnalysis(dayGanZhi, gender) {
    return getPillarAnalysis('day', dayGanZhi, gender)
}

function getTimePillarAnalysis(timeGanZhi, gender) {
    return getPillarAnalysis('time', timeGanZhi, gender)
}

// 初始化日期选择器
document.addEventListener('DOMContentLoaded', function() {
    // 天干地支奇偶规则
    const oddGan = ['甲', '丙', '戊', '庚', '壬']; // 奇数天干
    const evenGan = ['乙', '丁', '己', '辛', '癸']; // 偶数天干
    const oddZhi = ['子', '寅', '辰', '午', '申', '戌']; // 奇数地支
    const evenZhi = ['丑', '卯', '巳', '未', '酉', '亥']; // 偶数地支

    // 设置天干选择器的事件监听，以便根据选择的天干筛选可用的地支
    setupGanZhiFiltering('year-ganzhi', 'year-zhi');
    setupGanZhiFiltering('month-ganzhi', 'month-zhi');
    setupGanZhiFiltering('day-ganzhi', 'day-zhi');
    setupGanZhiFiltering('hour-ganzhi', 'hour-zhi');

    // 设置天干地支筛选功能
    function setupGanZhiFiltering(ganId, zhiId) {
        const ganSelect = document.getElementById(ganId);
        const zhiSelect = document.getElementById(zhiId);

        ganSelect.addEventListener('change', function() {
            const selectedGan = this.value;
            // 如果没有选择天干，则不限制地支选择
            if (!selectedGan) {
                enableAllZhi(zhiSelect);
                return;
            }

            // 根据天干的奇偶性筛选可用的地支
            const isOddGan = oddGan.includes(selectedGan);
            const validZhi = isOddGan ? oddZhi : evenZhi;

            // 保存当前的选择
            const currentSelection = zhiSelect.value;

            // 禁用不匹配的地支选项
            Array.from(zhiSelect.options).forEach(option => {
                const zhi = option.value;
                if (!zhi) return; // 跳过空选项

                // 设置选项是否可用
                if (!validZhi.includes(zhi)) {
                    option.disabled = true;
                    option.style.color = '#aaa';
                } else {
                    option.disabled = false;
                    option.style.color = '';
                }
            });

            // 如果当前选项不再有效，则重置选择
            if (currentSelection && !validZhi.includes(currentSelection)) {
                zhiSelect.value = '';
            }
        });
    }

    // 启用所有地支选项
    function enableAllZhi(zhiSelect) {
        Array.from(zhiSelect.options).forEach(option => {
            option.disabled = false;
            option.style.color = '';
        });
    }

    // 初始化年份 (1900-2100)
    const yearSelect = document.getElementById('year');
    for (let year = 1900; year <= 2100; year++) {
        const option = document.createElement('option');
        option.value = year;
        option.textContent = year + '年';
        yearSelect.appendChild(option);
    }

    // 设置默认年份为当前年份
    const currentYear = new Date().getFullYear();
    yearSelect.value = currentYear;

    // 初始化月份
    const monthSelect = document.getElementById('month');
    for (let month = 1; month <= 12; month++) {
        const option = document.createElement('option');
        option.value = month;
        option.textContent = month + '月';
        monthSelect.appendChild(option);
    }

    // 设置默认月份为当前月份
    const currentMonth = new Date().getMonth() + 1;
    monthSelect.value = currentMonth;

    // 初始化日期
    updateDays();

    // 初始化小时
    const hourSelect = document.getElementById('hour');
    const hourNames = ['子时 (23:00-01:00)', '丑时 (01:00-03:00)', '寅时 (03:00-05:00)',
        '卯时 (05:00-07:00)', '辰时 (07:00-09:00)', '巳时 (09:00-11:00)',
        '午时 (11:00-13:00)', '未时 (13:00-15:00)', '申时 (15:00-17:00)',
        '酉时 (17:00-19:00)', '戌时 (19:00-21:00)', '亥时 (21:00-23:00)'
    ];

    for (let i = 0; i < 12; i++) {
        const option = document.createElement('option');
        option.value = i;
        option.textContent = hourNames[i];
        hourSelect.appendChild(option);
    }

    // 月份变化时更新日期
    monthSelect.addEventListener('change', updateDays);
    yearSelect.addEventListener('change', updateDays);

    // 生成报告按钮事件
    document.getElementById('generate-report-btn').addEventListener('click', generateFullReport);

    // 重置按钮事件
    document.getElementById('reset-btn').addEventListener('click', resetForm);

    // 性别选择事件 - 左侧
    const leftGenderOptions = document.querySelectorAll('.gender-select:not(.right-gender) .gender-option');
    leftGenderOptions.forEach(option => {
        option.addEventListener('click', function() {
            // 移除所有选中状态
            leftGenderOptions.forEach(opt => opt.classList.remove('selected'));
            // 添加当前选中状态
            this.classList.add('selected');
        });
    });

    // 性别选择事件 - 右侧
    const rightGenderOptions = document.querySelectorAll('.gender-select.right-gender .gender-option');
    rightGenderOptions.forEach(option => {
        option.addEventListener('click', function() {
            // 移除所有选中状态
            rightGenderOptions.forEach(opt => opt.classList.remove('selected'));
            // 添加当前选中状态
            this.classList.add('selected');
        });
    });
});

// 更新日期选择器
function updateDays() {
    const year = parseInt(document.getElementById('year').value);
    const month = parseInt(document.getElementById('month').value);
    const daySelect = document.getElementById('day');

    // 清除现有选项
    daySelect.innerHTML = '';

    // 计算当前月份的天数
    const daysInMonth = new Date(year, month, 0).getDate();

    // 添加日期选项
    for (let day = 1; day <= daysInMonth; day++) {
        const option = document.createElement('option');
        option.value = day;
        option.textContent = day + '日';
        daySelect.appendChild(option);
    }

    // 设置默认日期为当天
    const currentDay = new Date().getDate();
    if (currentDay <= daysInMonth) {
        daySelect.value = currentDay;
    }
}

// 获取当前选择的性别
function getSelectedGender(isRightSection = false) {
    const selector = isRightSection ?
        '.gender-select.right-gender .gender-option.selected' :
        '.gender-select:not(.right-gender) .gender-option.selected';
    const selectedOption = document.querySelector(selector);
    return selectedOption ? selectedOption.getAttribute('data-gender') : '男'; // 默认为男
}

// 获取八字分析解释
async function getBaZiAnalysis(yearGanZhi, monthGanZhi, dayGanZhi, timeGanZhi, gender) {
    try {
        // 并行获取所有柱的解析
        const [year, month, day, time] = await Promise.all([
            getYearPillarAnalysis(yearGanZhi, gender),
            getMonthPillarAnalysis(monthGanZhi, gender),
            getDayPillarAnalysis(dayGanZhi, gender),
            getTimePillarAnalysis(timeGanZhi, gender)
        ]);

        return {
            year: {
                title: '年柱解析',
                content: year
            },
            month: {
                title: '月柱解析',
                content: month
            },
            day: {
                title: '日柱解析',
                content: day
            },
            time: {
                title: '时柱解析',
                content: time
            },
            overall: {
                title: '综合分析',
                content: getOverallAnalysis(yearGanZhi, monthGanZhi, dayGanZhi, timeGanZhi, gender)
            }
        };
    } catch (error) {
        console.error('获取八字分析时出错:', error);
        return {
            year: {
                title: '年柱解析',
                content: '解析失败'
            },
            month: {
                title: '月柱解析',
                content: '解析失败'
            },
            day: {
                title: '日柱解析',
                content: '解析失败'
            },
            time: {
                title: '时柱解析',
                content: '解析失败'
            },
            overall: {
                title: '综合分析',
                content: '无法完成综合分析'
            }
        };
    }
}

// 综合分析
function getOverallAnalysis(yearGanZhi, monthGanZhi, dayGanZhi, timeGanZhi, gender) {
    // 这里可以根据四柱的组合提供综合分析
    // 示例实现，实际应用中可能需要更复杂的逻辑
    return `四柱组合为: ${yearGanZhi}年 ${monthGanZhi}月 ${dayGanZhi}日 ${timeGanZhi}时，性别为${gender}，综合分析结果需根据专业命理学进行深入解读。`;
}

// 计算五行分布
function calculateWuXingDistribution(yearGanZhi, monthGanZhi, dayGanZhi, timeGanZhi) {
    // 五行映射表
    const wuXingMap = {
        // 天干
        '甲': '木',
        '乙': '木',
        '丙': '火',
        '丁': '火',
        '戊': '土',
        '己': '土',
        '庚': '金',
        '辛': '金',
        '壬': '水',
        '癸': '水',
        // 地支
        '寅': '木',
        '卯': '木',
        '巳': '火',
        '午': '火',
        '辰': '土',
        '丑': '土',
        '戌': '土',
        '未': '土',
        '申': '金',
        '酉': '金',
        '亥': '水',
        '子': '水'
    };

    // 地支藏干映射表
    const cangGanMap = {
        '寅': ['甲', '丙', '戊'],
        '卯': ['乙'],
        '辰': ['戊', '乙', '癸'],
        '巳': ['丙', '庚', '戊'],
        '午': ['丁', '己'],
        '未': ['己', '丁', '乙'],
        '申': ['庚', '壬', '戊'],
        '酉': ['辛'],
        '戌': ['戊', '辛', '丁'],
        '亥': ['壬', '甲'],
        '子': ['癸'],
        '丑': ['己', '癸', '辛']
    };

    // 初始化五行计数
    const wuXingCount = {
        '木': 0,
        '火': 0,
        '土': 0,
        '金': 0,
        '水': 0
    };

    // 初始化带藏干的五行计数
    const wuXingWithCangGanCount = {
        '木': 0,
        '火': 0,
        '土': 0,
        '金': 0,
        '水': 0
    };

    // 四柱八字
    const ganZhiList = [yearGanZhi, monthGanZhi, dayGanZhi, timeGanZhi];

    // 计算不含藏干的五行分布
    ganZhiList.forEach(ganZhi => {
        if (ganZhi && ganZhi.length === 2) {
            const gan = ganZhi.charAt(0); // 天干
            const zhi = ganZhi.charAt(1); // 地支

            // 累加天干的五行
            if (wuXingMap[gan]) {
                wuXingCount[wuXingMap[gan]]++;
            }

            // 累加地支的五行
            if (wuXingMap[zhi]) {
                wuXingCount[wuXingMap[zhi]]++;
            }

            // 带藏干的计算同样累加天干和地支
            if (wuXingMap[gan]) {
                wuXingWithCangGanCount[wuXingMap[gan]]++;
            }

            if (wuXingMap[zhi]) {
                wuXingWithCangGanCount[wuXingMap[zhi]]++;
            }

            // 累加藏干的五行
            if (cangGanMap[zhi]) {
                cangGanMap[zhi].forEach(hiddenGan => {
                    if (wuXingMap[hiddenGan]) {
                        wuXingWithCangGanCount[wuXingMap[hiddenGan]]++;
                    }
                });
            }
        }
    });

    // 将五行按数量从大到小排序
    const sortWuXing = (wuXingObj) => {
        return Object.entries(wuXingObj)
            .sort((a, b) => b[1] - a[1])
            .map(entry => `${entry[0]}(${entry[1]})`)
            .join(' ');
    };

    return {
        withoutCangGan: sortWuXing(wuXingCount),
        withCangGan: sortWuXing(wuXingWithCangGanCount)
    };
}

// 整合功能：执行转换并生成详细报告
async function generateFullReport() {
    // 显示全局加载指示器
    showGlobalLoading();
    
    try {
        // 先执行转换功能，传递 true 表示这是生成报告的模式
        await convert(true);
        
    } catch (error) {
        console.error("生成完整报告过程中出错:", error);
        document.querySelector('.result-content').innerHTML = `<p class="error">处理过程中出错: ${error.message}</p>`;
    } finally {
        // 隐藏加载指示器
        hideGlobalLoading();
    }
}

// 转换功能
async function convert(isForReport = false) {
    // 显示全局加载指示器
    showGlobalLoading();
    try {
        const calendarType = document.querySelector('input[name="calendar-type"]:checked').value;
        const year = parseInt(document.getElementById('year').value);
        const month = parseInt(document.getElementById('month').value);
        const day = parseInt(document.getElementById('day').value);
        const hourElement = document.getElementById('hour');
        const hour = hourElement.options[hourElement.selectedIndex].text;

        // 结果容器
        const resultContent = document.querySelector('.result-content');
        if (!isForReport) {
            resultContent.innerHTML = '<div class="loading">加载中...</div>';
        }

        // 检查八字输入（合并天干和地支）
        const yearGan = document.getElementById('year-ganzhi').value;
        const yearZhi = document.getElementById('year-zhi').value;
        const monthGan = document.getElementById('month-ganzhi').value;
        const monthZhi = document.getElementById('month-zhi').value;
        const dayGan = document.getElementById('day-ganzhi').value;
        const dayZhi = document.getElementById('day-zhi').value;
        const hourGan = document.getElementById('hour-ganzhi').value;
        const hourZhi = document.getElementById('hour-zhi').value;

        // 组合成完整的干支
        const yearGanZhi = yearGan && yearZhi ? yearGan + yearZhi : '';
        const monthGanZhi = monthGan && monthZhi ? monthGan + monthZhi : '';
        const dayGanZhi = dayGan && dayZhi ? dayGan + dayZhi : '';
        const timeGanZhi = hourGan && hourZhi ? hourGan + hourZhi : '';

        // 检查是否有完整的八字输入
        const hasBaZiInput = yearGanZhi && monthGanZhi && dayGanZhi && timeGanZhi;

        // 获取性别信息
        const gender = hasBaZiInput ? getSelectedGender(true) : getSelectedGender(false);

        // 优先处理八字转换，如果八字输入完整
        if (hasBaZiInput) {
            try {
                // 设置参数，流派为2，基准年为1900
                const sect = 2;
                const baseYear = 1900;

                // 使用 Solar.fromBaZi 查询匹配的阳历日期
                const matches = Solar.fromBaZi(yearGanZhi, monthGanZhi, dayGanZhi, timeGanZhi, sect, baseYear);
                console.log("八字匹配结果:", matches);

                if (matches && matches.length > 0) {
                    // 获取当前日期
                    const now = new Date();
                    const currentYear = now.getFullYear();

                    // 查找最接近当前年份的日期
                    let closestMatch = matches[0];
                    let minDiff = Math.abs(closestMatch.getYear() - currentYear);

                    for (let i = 1; i < matches.length; i++) {
                        const diff = Math.abs(matches[i].getYear() - currentYear);
                        if (diff < minDiff) {
                            minDiff = diff;
                            closestMatch = matches[i];
                        }
                    }

                    // 获取匹配日期的详细信息
                    const matchLunar = closestMatch.getLunar();
                    // 获取八字信息
                    const eightChar = matchLunar.getEightChar();

                    let output = `<p><strong>性别：</strong>${gender}</p>
                                         <p><strong>找到 ${matches.length} 个匹配日期，最接近当前年份的是：</strong></p>
                                         <p><strong>阳历：</strong>${closestMatch.getYear()}年 ${closestMatch.getMonth()}月 ${closestMatch.getDay()}日 ${matchLunar.getTimeZhi()}时 星期${closestMatch.getWeekInChinese()}</p>
                                         <p><strong>阴历：</strong>${matchLunar.getYearInChinese()}年 ${matchLunar.getMonthInChinese()}月 ${matchLunar.getDayInChinese()}</p>
                                         <p><strong>农历节日：</strong>${matchLunar.getFestivals().join('、') || '无'}</p>
                                         <p><strong>八字：</strong>${eightChar.getYear()} ${eightChar.getMonth()} ${eightChar.getDay()} ${eightChar.getTime()}</p>
                                         <p><strong>五行：</strong>年(${eightChar.getYearNaYin()}) 月(${eightChar.getMonthNaYin()}) 日(${eightChar.getDayNaYin()}) 时(${eightChar.getTimeNaYin()})</p>
                                         <p><strong>十神：</strong>年干(${eightChar.getYearShiShenGan()}) 月干(${eightChar.getMonthShiShenGan()}) 日干(${eightChar.getDayShiShenGan()}) 时干(${eightChar.getTimeShiShenGan()})</p>
                                         <p><strong>生肖：</strong>${matchLunar.getYearShengXiao()}</p>
                                         <p><strong>星座：</strong>${closestMatch.getXingZuo()}</p>`;

                    // 如果有多个匹配结果，显示其他匹配的年份
                    if (matches.length > 1) {
                        output += `<p><strong>其他匹配年份：</strong>`;
                        const otherYears = matches
                            .filter(m => m.getYear() !== closestMatch.getYear())
                            .map(m => m.getYear())
                            .sort((a, b) => a - b);
                        output += otherYears.join(', ');
                        output += `</p>`;
                    }

                    // 如果是生成报告模式，直接生成详细报告
                    if (isForReport) {
                        await generateDetailedReport(output);
                    } else {
                        resultContent.innerHTML = output;
                        // 获取八字分析结果
                        const analysis = await getBaZiAnalysis(yearGanZhi, monthGanZhi, dayGanZhi, timeGanZhi, gender);
                        // 将八字分析结果添加到显示内容中
                        await appendBaZiAnalysisToResult(analysis, resultContent, false);
                    }
                    return; // 已经处理完八字转换，直接返回
                } else {
                    resultContent.innerHTML = `<p>没有找到匹配的八字日期</p>`;
                    return; // 已经处理完八字转换，直接返回
                }
            } catch (e) {
                resultContent.innerHTML = `<p>八字查询出错：${e.message}</p>`;
                console.error("八字转换错误:", e);
                return; // 错误处理后返回
            }
        }

        // 如果没有完整的八字输入或八字转换失败，尝试通过日期转换
        if (year && month && day) {
            try {
                // 提取时间
                let timeValue = "00:00";
                let hourIndex = hourElement.selectedIndex; // 保存时辰索引
                let hourText = hour.replace(/\([^)]+\)/, "").trim(); // 获取时辰名称，如"子时"
                let hourRange = ""; // 存储时间范围，如"23:00-01:00"

                if (hour) {
                    // 从时辰字符串中提取时间部分
                    const match = hour.match(/\(([^)]+)\)/);
                    if (match && match[1]) {
                        hourRange = match[1];
                        timeValue = hourRange.split('-')[0]; // 取范围的起始时间
                    }
                }

                // 创建完整的日期时间字符串
                const dateString = `${year}-${month < 10 ? '0' + month : month}-${day < 10 ? '0' + day : day} ${timeValue}:00`;

                // 创建日期对象
                const date = new Date(dateString);

                // 提取小时和分钟
                const hours = parseInt(timeValue.split(':')[0]);
                const minutes = parseInt(timeValue.split(':')[1]);

                let output = '';
                let yearGanZhi, monthGanZhi, dayGanZhi, timeGanZhi;
                let eightChar;

                if (calendarType === 'solar') {
                    // 阳历转阴历
                    const solar = Solar.fromDate(date);
                    const lunar = solar.getLunar();

                    // 使用 EightChar 获取八字信息
                    eightChar = lunar.getEightChar();

                    // 获取四柱干支
                    yearGanZhi = eightChar.getYear();
                    monthGanZhi = eightChar.getMonth();
                    dayGanZhi = eightChar.getDay();
                    timeGanZhi = eightChar.getTime();

                    output = `<p><strong>性别：</strong>${gender}</p>
                                 <p><strong>阳历：</strong>${solar.getYear()}年 ${solar.getMonth()}月 ${solar.getDay()}日 ${hourText} (${hourRange}) 星期${solar.getWeekInChinese()}</p>
                                 <p><strong>阴历：</strong>${lunar.getYearInChinese()}年 ${lunar.getMonthInChinese()}月 ${lunar.getDayInChinese()}</p>
                                 <p><strong>农历节日：</strong>${lunar.getFestivals().join('、') || '无'}</p>
                                 <p><strong>八字：</strong>${yearGanZhi} ${monthGanZhi} ${dayGanZhi} ${timeGanZhi}</p>
                                 <p><strong>五行：</strong>年(${eightChar.getYearNaYin()}) 月(${eightChar.getMonthNaYin()}) 日(${eightChar.getDayNaYin()}) 时(${eightChar.getTimeNaYin()})</p>
                                 <p><strong>十神：</strong>年干(${eightChar.getYearShiShenGan()}) 月干(${eightChar.getMonthShiShenGan()}) 日干(${eightChar.getDayShiShenGan()}) 时干(${eightChar.getTimeShiShenGan()})</p>
                                 <p><strong>生肖：</strong>${lunar.getYearShengXiao()}</p>
                                 <p><strong>星座：</strong>${solar.getXingZuo()}</p>`;
                } else {
                    // 阴历转阳历
                    const lunar = Lunar.fromYmdHms(year, month, day, hours, minutes, 0);
                    const solar = lunar.getSolar();

                    // 使用 EightChar 获取八字信息
                    eightChar = lunar.getEightChar();

                    // 获取四柱干支
                    yearGanZhi = eightChar.getYear();
                    monthGanZhi = eightChar.getMonth();
                    dayGanZhi = eightChar.getDay();
                    timeGanZhi = eightChar.getTime();

                    output = `<p><strong>性别：</strong>${gender}</p>
                                 <p><strong>阴历：</strong>${lunar.getYearInChinese()}年 ${lunar.getMonthInChinese()}月 ${lunar.getDayInChinese()}</p>
                                 <p><strong>阳历：</strong>${solar.getYear()}年 ${solar.getMonth()}月 ${solar.getDay()}日 ${hourText} (${hourRange}) 星期${solar.getWeekInChinese()}</p>
                                 <p><strong>农历节日：</strong>${lunar.getFestivals().join('、') || '无'}</p>
                                 <p><strong>八字：</strong>${yearGanZhi} ${monthGanZhi} ${dayGanZhi} ${timeGanZhi}</p>
                                 <p><strong>五行：</strong>年(${eightChar.getYearNaYin()}) 月(${eightChar.getMonthNaYin()}) 日(${eightChar.getDayNaYin()}) 时(${eightChar.getTimeNaYin()})</p>
                                 <p><strong>十神：</strong>年干(${eightChar.getYearShiShenGan()}) 月干(${eightChar.getMonthShiShenGan()}) 日干(${eightChar.getDayShiShenGan()}) 时干(${eightChar.getTimeShiShenGan()})</p>
                                 <p><strong>生肖：</strong>${lunar.getYearShengXiao()}</p>
                                 <p><strong>星座：</strong>${solar.getXingZuo()}</p>`;
                }

                // 如果是生成报告模式，直接生成详细报告
                if (isForReport) {
                    await generateDetailedReport(output);
                } else {
                    resultContent.innerHTML = output;
                    // 获取八字分析结果
                    const analysis = await getBaZiAnalysis(yearGanZhi, monthGanZhi, dayGanZhi, timeGanZhi, gender);
                    // 将八字分析结果添加到显示内容中
                    await appendBaZiAnalysisToResult(analysis, resultContent);
                }

            } catch (e) {
                resultContent.innerHTML = `<p>日期转换出错：${e.message}</p>`;
                console.error(e);
            }
        }
    } catch (error) {
        console.error("转换过程中出错:", error);
        if (!isForReport) {
            document.querySelector('.result-content').innerHTML = `<p class="error">处理过程中出错: ${error.message}</p>`;
        }
    } finally {
        // 无论成功与否，最后都隐藏加载指示器
        if (!isForReport) {
            hideGlobalLoading();
        }
    }
}

// 重置表单
function resetForm() {
    // 重置历法选择
    document.querySelector('input[name="calendar-type"][value="solar"]').checked = true;

    // 重置日期选择器
    const currentYear = new Date().getFullYear();
    document.getElementById('year').value = currentYear;

    const currentMonth = new Date().getMonth() + 1;
    document.getElementById('month').value = currentMonth;

    updateDays();
    document.getElementById('hour').selectedIndex = 0;

    // 重置八字选择
    const ganzhiSelects = document.querySelectorAll('.ganzhi-select select');
    ganzhiSelects.forEach(select => {
        select.selectedIndex = 0;
    });

    // 重置性别选择（恢复为"男"）
    const allGenderOptions = document.querySelectorAll('.gender-option');
    allGenderOptions.forEach(option => {
        if (option.getAttribute('data-gender') === '男') {
            option.classList.add('selected');
        } else {
            option.classList.remove('selected');
        }
    });

    // 重置结果区域
    document.querySelector('.result-content').innerHTML = '<p>请选择日期或输入八字进行查询...</p>';
}

// 绘制五行分布图表
function drawWuXingChart(canvasId, distributionData, title) {
    // 解析分布数据
    const regex = /([木火土金水])\((\d+)\)/g;
    const data = [];
    let match;
    
    while ((match = regex.exec(distributionData)) !== null) {
        data.push({
            element: match[1],
            count: parseInt(match[2])
        });
    }
    
    // 按数量排序
    data.sort((a, b) => b.count - a.count);
    
    // 五行颜色映射
    const colors = {
        '木': 'rgba(46, 204, 113, 0.8)',    // 鲜绿色
        '火': 'rgba(231, 76, 60, 0.8)',     // 鲜红色
        '土': 'rgba(155, 89, 182, 0.8)',    // 紫色
        '金': 'rgba(241, 196, 15, 0.8)',    // 金色
        '水': 'rgba(52, 152, 219, 0.8)'     // 蓝色
    };
    
    // 五行解释
    const elementNames = {
        '木': '木 (生长、创造)',
        '火': '火 (热情、行动)',
        '土': '土 (稳定、支持)',
        '金': '金 (决断、收获)',
        '水': '水 (智慧、流动)'
    };
    
    // 创建图表
    const ctx = document.getElementById(canvasId).getContext('2d');
    new Chart(ctx, {
        type: 'doughnut',  // 环形图
        data: {
            labels: data.map(item => `${elementNames[item.element]}: ${item.count}`),
            datasets: [{
                data: data.map(item => item.count),
                backgroundColor: data.map(item => colors[item.element]),
                borderWidth: 1,
                hoverOffset: 15
            }]
        },
        options: {
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
                legend: {
                    position: 'right',
                    labels: {
                        font: {
                            size: 12
                        },
                        padding: 15
                    }
                },
                title: {
                    display: true,
                    text: title,
                    font: {
                        size: 16,
                        weight: 'bold'
                    },
                    padding: {
                        top: 10,
                        bottom: 20
                    }
                },
                tooltip: {
                    callbacks: {
                        label: function(context) {
                            const label = context.label || '';
                            const value = context.raw || 0;
                            const total = context.dataset.data.reduce((a, b) => a + b, 0);
                            const percentage = Math.round((value / total) * 100);
                            return `${label.split(':')[0]}: ${value} (${percentage}%)`;
                        }
                    }
                }
            },
            animation: {
                animateScale: true,
                animateRotate: true,
                duration: 2000
            }
        }
    });
}

// 将八字分析添加到结果中
async function appendBaZiAnalysisToResult(analysis, resultContent, showAnalysis = true) {
    try {
        // 等待分析结果解析完成
        const analysisData = await analysis;

        // 如果不显示分析结果，直接返回
        if (!showAnalysis) {
            return;
        }

        let analysisHtml = `<div class="bazi-analysis">
                           <h3 class="analysis-title">八字详解</h3>`;

        // 添加各柱解析
        for (const key in analysisData) {
            if (analysisData[key].content) {
                analysisHtml += `<div class="analysis-item">
                                        <h4>${analysisData[key].title}</h4>
                                        <p>${analysisData[key].content}</p>
                                       </div>`;
            }
        }

        // 添加五行分析
        // 1. 获取四柱八字的完整干支
        // 从当前HTML中获取已经显示的八字信息
        let baziText = resultContent.innerText;
        let yearGanZhi = '',
            monthGanZhi = '',
            dayGanZhi = '',
            timeGanZhi = '';

        // 尝试从结果内容中提取八字信息
        const baziMatch = baziText.match(/八字：\s*([甲乙丙丁戊己庚辛壬癸][子丑寅卯辰巳午未申酉戌亥])\s+([甲乙丙丁戊己庚辛壬癸][子丑寅卯辰巳午未申酉戌亥])\s+([甲乙丙丁戊己庚辛壬癸][子丑寅卯辰巳午未申酉戌亥])\s+([甲乙丙丁戊己庚辛壬癸][子丑寅卯辰巳午未申酉戌亥])/);

        if (baziMatch) {
            // 如果从结果中找到了八字信息，使用它们
            yearGanZhi = baziMatch[1];
            monthGanZhi = baziMatch[2];
            dayGanZhi = baziMatch[3];
            timeGanZhi = baziMatch[4];
        } else {
            // 如果没有从结果中找到，尝试从八字输入框获取
            yearGanZhi = document.getElementById('year-ganzhi').value + document.getElementById('year-zhi').value;
            monthGanZhi = document.getElementById('month-ganzhi').value + document.getElementById('month-zhi').value;
            dayGanZhi = document.getElementById('day-ganzhi').value + document.getElementById('day-zhi').value;
            timeGanZhi = document.getElementById('hour-ganzhi').value + document.getElementById('hour-zhi').value;
        }

        // 2. 计算五行分布
        const wuXingAnalysis = calculateWuXingDistribution(yearGanZhi, monthGanZhi, dayGanZhi, timeGanZhi);

        // 3. 五行元素解释数据库
        const wuXingDescriptions = {};
        const elements = ['木', '火', '土', '金', '水'];

        // 并行获取所有五行描述
        const descriptionPromises = [];
        for (const element of elements) {
            // 获取"代表"部分（使用common）
            descriptionPromises.push(
                getWuXingDescription(element, 'common')
                .then(result => {
                    wuXingDescriptions[element] = wuXingDescriptions[element] || {};
                    wuXingDescriptions[element]['代表'] = result;
                })
            );

            // 获取"旺"部分（使用男性）
            descriptionPromises.push(
                getWuXingDescription(element, '男')
                .then(result => {
                    wuXingDescriptions[element] = wuXingDescriptions[element] || {};
                    wuXingDescriptions[element]['旺'] = result;
                })
            );

            // 获取"弱"部分（使用女性）
            descriptionPromises.push(
                getWuXingDescription(element, '女')
                .then(result => {
                    wuXingDescriptions[element] = wuXingDescriptions[element] || {};
                    wuXingDescriptions[element]['弱'] = result;
                })
            );
        }

        // 等待所有描述获取完成
        await Promise.all(descriptionPromises);

        // 4. 获取强弱元素排序
        const getStrongestAndWeakest = (wuXingResult) => {
            // 解析字符串，例如 "木(3) 水(2) 火(1) 土(1) 金(1)" 转换为对象 {木: 3, 水: 2, 火: 1, 土: 1, 金: 1}
            if (!wuXingResult) return {
                strongest: [],
                weakest: []
            };

            const elements = {};
            const regex = /([木火土金水])\((\d+)\)/g;
            let match;

            while ((match = regex.exec(wuXingResult)) !== null) {
                elements[match[1]] = parseInt(match[2]);
            }

            // 按值排序
            const sorted = Object.entries(elements).sort((a, b) => b[1] - a[1]);

            // 获取最强的两个元素（如果存在）
            const strongest = sorted.slice(0, 2).map(item => item[0]);

            // 获取最弱的两个元素（如果存在）
            const weakest = sorted.slice(-2).map(item => item[0]).reverse();

            return {
                strongest,
                weakest
            };
        };

        // 5. 分析不含藏干的五行
        const withoutCangGanAnalysis = getStrongestAndWeakest(wuXingAnalysis.withoutCangGan);

        // 6. 分析含藏干的五行
        const withCangGanAnalysis = getStrongestAndWeakest(wuXingAnalysis.withCangGan);

        // 7. 生成描述文本
        const generateDescription = (analysis) => {
            let description = '';

            // 添加最强元素描述
            if (analysis.strongest.length > 0) {
                description += '<h5>最旺元素解析</h5>';
                analysis.strongest.forEach(element => {
                    description += `<p><strong>${element}：</strong>${wuXingDescriptions[element]?.['代表'] || ''}</p>`;
                    description += `<p>${wuXingDescriptions[element]?.['旺'] || ''}</p>`;
                });
            }

            // 添加最弱元素描述
            if (analysis.weakest.length > 0) {
                description += '<h5>最弱元素解析</h5>';
                analysis.weakest.forEach(element => {
                    description += `<p><strong>${element}：</strong>${wuXingDescriptions[element]?.['代表'] || ''}</p>`;
                    description += `<p>${wuXingDescriptions[element]?.['弱'] || ''}</p>`;
                });
            }

            return description;
        };

        // 添加五行分析到结果中 - 包含图表
        analysisHtml += `<div class="analysis-item">
                                <h4>五行分析</h4>
                                
                                <div class="wuxing-charts">
                                    <div class="wuxing-chart">
                                        <h5>不含藏干的五行分布</h5>
                                        <p>${wuXingAnalysis.withoutCangGan}</p>
                                        <canvas id="chart-without-canggan"></canvas>
                                        <hr style="margin: 15px 0;">
                                        <p>${generateDescription(withoutCangGanAnalysis)}</p>
                                    </div>
                                    
                                    <div class="wuxing-chart">
                                        <h5>含藏干的五行分布</h5>
                                        <p>${wuXingAnalysis.withCangGan}</p>
                                        <canvas id="chart-with-canggan"></canvas>
                                        <hr style="margin: 15px 0;">
                                        <p>${generateDescription(withCangGanAnalysis)}</p>
                                    </div>
                                </div>
                             </div>`;
        
        analysisHtml += `</div>`;

        // 添加到结果内容中
        resultContent.innerHTML += analysisHtml;

        // 绘制图表
        drawWuXingChart('chart-without-canggan', wuXingAnalysis.withoutCangGan, '不含藏干五行分布');
        drawWuXingChart('chart-with-canggan', wuXingAnalysis.withCangGan, '含藏干五行分布');

    } catch (error) {
        console.error('解析八字分析时出错:', error);
        resultContent.innerHTML += `<div class="bazi-analysis">
                                   <h3 class="analysis-title">八字详解</h3>
                                   <p>解析服务暂时不可用</p>
                                   </div>`;
    }
}

// 生成详细报告
async function generateDetailedReport(currentResult) {
    try {
        // 获取当前日期时间
        const now = new Date();
        const currentDateTime = `${now.getFullYear()}年${now.getMonth() + 1}月${now.getDate()}日 ${formatTime(now)}`;
        
        // 从结果中提取性别信息
        const genderMatch = currentResult.match(/性别：(\S+)/);
        const gender = genderMatch ? genderMatch[1] : '未知';
        
        const aiProvider = 'deepseek';
        
        // 构建完整的提示词
        const fullPrompt = `你是一位融汇《三命通会》、《渊海子平》、《子平真诠》等经典的玄学大师，尤精于以《子平真诠》的格局理论为核心，并以十干调候、禄命神煞为辅助进行命理分析。

**用户数据**
请严格依据以下提供的命盘信息进行分析，不得自行排盘或计算大运。
\`\`\`
${currentResult}
当年阳历年月日：${currentDateTime}
\`\`\`

**任务要求**
请根据以上数据，生成一个包含以下八个部分的《综合命运分析套装》。每个报告都需遵循指定的分析方法和内容要求，确保专业、深入且结构清晰。
不得自行排盘或计算大运。
要是涉及到于是年份的请无比用天干地支来表示而不要自行计算公元年份。
不要添加任何免责声明，或者说明这是AI生成的。

---

### **基础信息**
以表格形式呈现，内容须包含：
- **柱位**（年柱、月柱、日柱、时柱）
- **干神**（对应的十神）
- **天干**
- **地支**
- **藏干**（请自动提取并解释）
- **支神**（如桃花、华盖、驿马等，请自动识别）
- **纳音**
- **神煞**（如天乙贵人、学堂星、灾煞等，请自动识别并列出）

### **性格与人生蓝图**
**分析方法**：检查日主强度、五行平衡、阴阳平衡及关键星象组合（如学堂星、桃花、贵人、华盖等），解读生命结构（如性格、人生角色和战略潜力）。
- **先天特质与原型**：揭示核心特征、他人感知、优势与局限性。
- **生命结构与目标**：定义对职业、人际关系和成功的策略。
- **战略调整**：建议如何结合自然倾向与有利环境来导航人生道路。

### **爱情与关系动态**
**分析方法**：解码配偶星位置与强度、桃花星及其对吸引力和受欢迎程度的影响、基于阴阳和元素流动的情感倾向，以及运柱/年运中的浪漫机会时机。
- **情感原型与模式**：解读浪漫行为、情感深度、给予与接受爱的模式。
- **理想匹配蓝图**：基于命盘极性与元素构成，描述兼容伴侣的能量特征。
- **爱情时机窗口**：指出人生中浪漫、婚姻与情感清晰的高峰期。

### **财富与丰盛流动**
**分析方法**：检查财星及其与日主的互动、财富结构类型（直接/间接/混合）、财富星的质量、强度和稳定性，以及年运中的财富机会周期。
- **财富获取模式**：说明自然财富生成倾向与最可能的成功途径。
- **财务决策风格**：判断风格（保守/平衡/进取）及优化建议。
- **财富时机周期**：识别生命周期中的财富高峰期与挑战期。

### **职业与目标对齐**
**分析方法**：检查才能星与职业指标、权威与领导风格、最适合能量的工作环境，以及职业周期与关键转变点。
- **天赋与职业适配**：阐明先天才能如何转化为职业选择与专业优势。
- **工作风格与环境**：指出茁壮成长的工作环境与理想领导/协作风格。
- **职业转变时机**：识别职业变化、晋升与新机会的最佳时机窗口。

### **健康与能量平衡**
**分析方法**：检查体质类型与元素失衡、健康优势与脆弱点、压力反应与恢复模式，以及季节性健康波动。
- **体质与能量倾向**：说明先天体质类型对能量水平、恢复力与健康的影响。
- **健康优化策略**：提供针对性的饮食、运动与生活方式建议。
- **预防与平衡**：指出需要特别关注的健康领域及保持平衡的预防性实践。

### **本年运策略（基于提供的"当年阳历年月日"）**
**分析方法**：检查该年（按照用户输入的当年阳历年月日自动识别）年柱与命盘的互动、年度五行能量与日主关系、年度吉凶星象影响，以及月度能量变化。
- **年度机遇与挑战**：说明该年特定的机遇与挑战及导航策略。
- **关键决策时机**：识别年内做出重要决定、启动项目的最佳月份。
- **关系与职业影响**：探索年度能量对人际关系、职业发展与个人成长的影响。

### **本月运能量流动（基于提供的"当年阳历年月日"推导出当月）**
**分析方法**：检查该月（按照用户输入的当年阳历年月日自动识别）月柱与命盘的互动、月度五行能量与日主关系、月度吉凶星象影响，并推荐适合特定活动的日期范围。
- **月度重点领域**：指出该月哪些生活领域将受积极影响及可能面临的挑战。
- **时机优化**：识别月内最适合特定活动、会议与决策的时期。
- **能量管理**：建议如何根据月度能量波动管理精力、情绪与生产力。

### **未来一个月运能量流动（基于提供的"当年阳历年月日"推导出当月加1个月的月份）**
**分析方法**：检查该月（按照用户输入的当年阳历年月日自动识别）月柱与命盘的互动、月度五行能量与日主关系、月度吉凶星象影响，并推荐适合特定活动的日期范围。
- **月度重点领域**：指出该月哪些生活领域将受积极影响及可能面临的挑战。
- **时机优化**：识别月内最适合特定活动、会议与决策的时期。
- **能量管理**：建议如何根据月度能量波动管理精力、情绪与生产力。

### **未来两个月运能量流动（基于提供的"当年阳历年月日"推导出当月加2个月的月份）**
**分析方法**：检查该月（按照用户输入的当年阳历年月日自动识别）月柱与命盘的互动、月度五行能量与日主关系、月度吉凶星象影响，并推荐适合特定活动的日期范围。
- **月度重点领域**：指出该月哪些生活领域将受积极影响及可能面临的挑战。
- **时机优化**：识别月内最适合特定活动、会议与决策的时期。
- **能量管理**：建议如何根据月度能量波动管理精力、情绪与生产力。

### **未来三个月运能量流动（基于提供的"当年阳历年月日"推导出当月加3个月的月份）**
**分析方法**：检查该月（按照用户输入的当年阳历年月日自动识别）月柱与命盘的互动、月度五行能量与日主关系、月度吉凶星象影响，并推荐适合特定活动的日期范围。
- **月度重点领域**：指出该月哪些生活领域将受积极影响及可能面临的挑战。
- **时机优化**：识别月内最适合特定活动、会议与决策的时期。
- **能量管理**：建议如何根据月度能量波动管理精力、情绪与生产力。

---

请开始生成完整的《综合命运分析套装》。`;

        // 调用Cloudflare Worker API - 带超时和重试
        const maxRetries = 2;
        let lastError;
        
        for (let attempt = 1; attempt <= maxRetries; attempt++) {
            try {
                console.log(`API调用尝试 ${attempt}/${maxRetries}...`);
                
                const controller = new AbortController();
                const timeoutId = setTimeout(() => controller.abort(), 180000); // 180秒超时 (3分钟)
                
                const response = await fetch('https://fourpillarsofdestiny-full-api.hammett-qi.workers.dev/generate-report', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        prompt: fullPrompt,
                        timestamp: currentDateTime,
                        gender: gender,
                        ai_provider: aiProvider
                    }),
                    signal: controller.signal
                });

                clearTimeout(timeoutId);
                console.log('API响应状态:', response.status);
                console.log('API响应OK:', response.ok);

                if (!response.ok) {
                    const errorText = await response.text();
                    console.error('API错误响应:', errorText);
                    throw new Error(`API请求失败: ${response.status} - ${errorText}`);
                }

                const data = await response.json();
                console.log('API返回数据成功');
                
                if (data.success && data.report) {
                    // 直接在结果区域显示报告内容
                    displayReportContentDirectly(data.report);
                    return; // 成功，退出
                } else {
                    throw new Error(data.error || '生成报告失败');
                }
            } catch (error) {
                lastError = error;
                console.error(`尝试 ${attempt} 失败:`, error.message);
                
                if (attempt < maxRetries) {
                    console.log(`等待 ${attempt * 3} 秒后重试...`);
                    await new Promise(resolve => setTimeout(resolve, attempt * 3000));
                }
            }
        }
        
        // 所有重试都失败了
        throw lastError;

    } catch (error) {
        console.error('生成报告失败:', error);
        console.error('错误详情:', error.message);
        document.querySelector('.result-content').innerHTML = `
            <div class="report-error">
                <h3>报告生成失败</h3>
                <p>抱歉，生成详细报告时出现错误。请稍后重试。</p>
                <p>错误信息: ${error.message}</p>
            </div>
        `;
    } finally {
        hideGlobalLoading();
    }
}

// 格式化时间显示
function formatTime(date) {
    let hours = date.getHours();
    let minutes = date.getMinutes();
    const ampm = hours >= 12 ? 'PM' : 'AM';
    
    hours = hours % 12;
    hours = hours ? hours : 12;
    minutes = minutes < 10 ? '0' + minutes : minutes;
    
    return `${hours}:${minutes} ${ampm}`;
}

// 过滤AI生成声明语句的函数
function filterAIGeneratedStatements(content) {
    const aiStatements = [
        /以上内容由[\s\S]*生成，仅供娱乐参考/gi,
        /本报告由[\s\S]*AI[\s\S]*生成/gi,
        /AI生成的内容，仅供参考/gi,
        /由[\s\S]*AI模型生成/gi,
        /免责声明：[\s\S]*AI[\s\S]*生成/gi,
        /注：[\s\S]*AI[\s\S]*生成/gi,
        /本分析由[\s\S]*AI[\s\S]*提供/gi,
        /以上解析由[\s\S]*AI[\s\S]*生成/gi,
        /This response is [\s\S]*AI[\s\S]/gi,
        /for reference only./gi
    ];
    
    let filteredContent = content;
    
    aiStatements.forEach(pattern => {
        filteredContent = filteredContent.replace(pattern, '');
    });
    
    // 同时过滤掉空行和多余的换行
    filteredContent = filteredContent
        .replace(/\n\s*\n\s*\n/g, '\n\n') // 将多个连续空行合并为两个
        .trim();
    
    return filteredContent;
}

// 直接在结果区域显示报告内容
function displayReportContentDirectly(content) {
    const resultContent = document.querySelector('.result-content');
    

    const filteredContent = filterAIGeneratedStatements(content);
    

    // 简单格式化
    let formattedContent = filteredContent
        .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
        .replace(/\*(.*?)\*/g, '<em>$1</em>')
        .replace(/### (.*?)(?=\n|$)/g, '<h3 class="report-section-title">$1</h3>')
        .replace(/## (.*?)(?=\n|$)/g, '<h2 class="report-section-title">$1</h2>')
        .replace(/# (.*?)(?=\n|$)/g, '<h1 class="report-section-title">$1</h1>')
        .replace(/\n/g, '<br>');
    
        
    resultContent.innerHTML = `
        <div class="report-content-directly">
            <div class="report-header" style="text-align: center; margin-bottom: 20px; padding-bottom: 15px; border-bottom: 2px solid #C3272B;">
                <h2 style="color: #2c3e50; margin: 0;">详细命理分析报告</h2>
            </div>
            <div class="report-body" style="line-height: 1.8; color: #333;">
                ${formattedContent}
            </div>
        </div>
    `;
}